import React from "react";
import { fetchSearch, API_BASE, SEARCH_PAGE_SIZE } from "../utils";
import SearchDropdown from "./SearchDropdown";

const labelFor = ({ type, item }) =>
  type === "artist" || type === "set" ? item.name : item.title;

function resultImage({ type, item }) {
  if (type === "album") return `${API_BASE}/albums/${item.id}/image/`;
  if (type === "artist") return `${API_BASE}/artists/${item.id}/image/`;
  if (type === "set") return `${API_BASE}/user-sets/${item.id}/image/`;
  if (item.album_image) return item.album_image;
  const albumId =
    typeof item.album === "object"
      ? item.album?.id
      : item.album || item.album_id;
  return albumId ? `${API_BASE}/albums/${albumId}/image/` : null;
}

function renderResult(result) {
  const { type, item } = result;
  const image = resultImage(result);
  return (
    <>
      {image && <img src={image} alt="" />}
      <div className="album-search-info">
        <div className="title">{labelFor(result)}</div>
        {type === "album" && (
          <div className="artist">
            {item.artists
              ? item.artists.map((artist) => artist.name).join(", ")
              : item.artist}
          </div>
        )}
        {type === "track" && (
          <div className="artist">{item.album_title || item.album?.title}</div>
        )}
      </div>
    </>
  );
}

export default function CollectionSearchDropdown({
  onSelect,
  value,
  onChange,
  types = "",
  admin = false,
  above = false,
}) {
  const loadPage = React.useCallback(
    async (query, page, signal) => {
      const data = await fetchSearch({ query, page, types, admin, signal });
      return (data.results || []).map((item) => ({
        // Typed album/artist pickers historically accept responses without `type`.
        type: types === "album" || types === "artist" ? types : item.type,
        item,
      }));
    },
    [types, admin],
  );
  const label =
    types === "track"
      ? "Search tracks"
      : types === "set"
        ? "Search sets"
        : types === "album"
          ? "Search albums"
          : types === "artist"
            ? "Search artists"
            : "Search collection";
  return (
    <SearchDropdown
      value={value}
      onChange={onChange}
      onSelect={onSelect}
      loadPage={loadPage}
      pageSize={SEARCH_PAGE_SIZE}
      getKey={(result) => `${result.type}-${result.item.id}`}
      getLabel={labelFor}
      renderResult={renderResult}
      label={label}
      placeholder={
        types === "track"
          ? "Search tracks..."
          : types === "set"
            ? "Search sets..."
            : "Search..."
      }
      above={above}
    />
  );
}
